// Main wrapper content = toolbar + content (compare view / single view).
// Toolbar exposes: resolution-bar (left), view-mode controls, zoom controls,
// annotation controls (right). Matches legacy DOM index.html L1707-1762.

import { ContentView } from './ContentView';
import { RemarksTab } from './RemarksTab';
import { Toolbar } from './Toolbar';

export function MainView() {
  return (
    <>
      <Toolbar />
      <div style={{ display: 'flex', flex: 1, 'min-height': 0 }}>
        <ContentView />
        <RemarksTab />
      </div>
    </>
  );
}
